import { render, staticRenderFns } from "./OAuthConsent.vue?vue&type=template&id=7c0e6536&scoped=true"
import script from "./OAuthConsent.vue?vue&type=script&lang=js"
export * from "./OAuthConsent.vue?vue&type=script&lang=js"
import style0 from "./OAuthConsent.vue?vue&type=style&index=0&id=7c0e6536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0e6536",
  null
  
)

export default component.exports